"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_helmet_1 = require("react-helmet");
var Menu_1 = __importDefault(require("./components/Menu"));
var Skills_1 = __importDefault(require("./containers/Skills"));
var Projects_1 = __importDefault(require("./containers/Projects"));
var Experiences_1 = __importDefault(require("./containers/Experiences"));
var NoRoute_1 = __importDefault(require("./containers/NoRoute"));
var Profile_1 = __importDefault(require("./containers/Profile"));
var Layout_1 = require("./components/Layout");
var splashScreen_jpg_1 = __importDefault(require("-!file-loader!../client/assets/Pictures/splashScreen.jpg"));
var styled_components_1 = require("styled-components");
var LightContext_1 = __importDefault(require("./Context/LightContext"));
exports.GlobalStyle = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0;\n    background-color: ", ";\n    overflow-x: hidden;\n    transition: all 0.5s ease;\n  }\n"], ["\n  body {\n    font-family: \"Open Sans\", sans-serif;\n    margin: 0;\n    background-color: ", ";\n    overflow-x: hidden;\n    transition: all 0.5s ease;\n  }\n"])), function (p) { return p.background || "#bce4ff"; });
function App() {
    var _a = react_1.useState(true), lightOn = _a[0], setLightOn = _a[1];
    var url = process.env.PUBLIC_URL || "";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("link", { rel: "Gloria Luzio", href: "https://www.glorialuzio.fr" }),
            react_1.default.createElement("meta", { charSet: "utf-8" }),
            react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
            react_1.default.createElement("link", { href: "https://fonts.googleapis.com/css?family=Open+Sans:400,800|Vibur&display=swap", rel: "stylesheet" }),
            react_1.default.createElement("meta", { name: "google-site-verification", content: "-EWsw_AxjRTEKBu8AqwcWTkvFIi6Hw0p2nX55taEppE" }),
            react_1.default.createElement("meta", { property: "og:type", content: "website" }),
            react_1.default.createElement("meta", { property: "og:locale", content: "fr_FR" }),
            react_1.default.createElement("meta", { property: "og:image", content: url + splashScreen_jpg_1.default })),
        react_1.default.createElement(LightContext_1.default.Provider, { value: { lightOn: lightOn, switch: function () { return setLightOn(!lightOn); } } },
            react_1.default.createElement(Menu_1.default, null),
            react_1.default.createElement(exports.GlobalStyle, { background: !lightOn ? "#97b9d0" : undefined }),
            react_1.default.createElement(Layout_1.Container, { className: "container" },
                react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/" },
                        react_1.default.createElement(Profile_1.default, null)),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/competences" },
                        react_1.default.createElement(Skills_1.default, null)),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/projets" },
                        react_1.default.createElement(Projects_1.default, null)),
                    react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/experiences" },
                        react_1.default.createElement(Experiences_1.default, null)),
                    react_1.default.createElement(react_router_dom_1.Route, { component: NoRoute_1.default }))))));
}
exports.default = App;
var templateObject_1;
